import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgGridIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.02 2.2a2.121 2.121 0 0 0 4.24 0 2.121 2.121 0 0 0-4.24 0Zm1.25-.01a.87.87 0 1 1 1.741.001.87.87 0 0 1-1.741 0Zm4.65.01a2.121 2.121 0 0 0 4.24 0 2.121 2.121 0 0 0-4.24 0Zm1.25-.01c0-.48.39-.87.87-.87s.88.39.87.87a.87.87 0 0 1-1.74 0Zm6.72 2.13a2.121 2.121 0 0 1 0-4.24 2.121 2.121 0 0 1 0 4.24Zm0-3a.87.87 0 1 0 .001 1.741.87.87 0 0 0-.001-1.74ZM.02 8.01a2.121 2.121 0 0 0 4.24 0 2.121 2.121 0 0 0-4.24 0ZM1.27 8a.87.87 0 1 1 1.741.001.87.87 0 0 1-1.741 0Zm6.77 2.13a2.121 2.121 0 0 1 0-4.24 2.121 2.121 0 0 1 0 4.24Zm0-3a.87.87 0 1 0 .87.87.864.864 0 0 0-.87-.87Zm3.73.88a2.121 2.121 0 0 0 4.24 0 2.121 2.121 0 0 0-4.24 0ZM13.02 8a.87.87 0 1 1 1.741.001.87.87 0 0 1-1.741 0ZM2.14 15.94a2.121 2.121 0 0 1 0-4.24 2.121 2.121 0 0 1 0 4.24Zm0-3a.87.87 0 1 0 .87.87c0-.47-.39-.87-.87-.87Zm3.78.88a2.121 2.121 0 0 0 4.24 0 2.121 2.121 0 0 0-4.24 0Zm1.25-.01a.87.87 0 1 1 1.741.001.87.87 0 0 1-1.741-.001Zm6.72 2.13a2.121 2.121 0 0 1 0-4.24 2.121 2.121 0 0 1 0 4.24Zm0-3a.87.87 0 1 0 .87.87c0-.47-.39-.87-.87-.87Z",
    fill: "currentColor"
  }));
}

export { SvgGridIcon as default };
